import axios from 'axios';
import { from, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import * as _ from 'lodash';

import { IHelpFile, IPageContentInfo, IUpdatePageContentCommand } from 'src/models';
import { THelpType } from 'src/types';

export default {
    pageContentInfos$: undefined,
    /* private */ requestPageContentInfosObservable(
        enforceNew?: boolean // 强制获取最新数据，不取缓存
    ): Observable<IPageContentInfo[]> {
        if (enforceNew || !this.pageContentInfos$) {
            this.pageContentInfos$ = from(
                // Observable -> Promise
                axios.get<IPageContentInfo>(`/api/cms/pages`).then((res) => {
                    return res.data;
                })
            ).pipe(
                shareReplay(1), // 多播
                map((pageContentInfo) => _.cloneDeep(pageContentInfo))
            );
        }
        return this.pageContentInfos$;
    },
    /* private */ getPageContentInfos(enforceNew?: boolean): Promise<IPageContentInfo[]> {
        return this.requestPageContentInfosObservable(enforceNew).toPromise();
    },
    /* private */ updatePageContent(
        updatePageContentCommand: IUpdatePageContentCommand
    ): Promise<boolean> {
        return axios.post<boolean>(`/api/cms/pages`, updatePageContentCommand).then((res) => {
            return res.data;
        });
    },

    getNotice(enforceNew?: boolean): Promise<string> {
        const key: THelpType = 'Notice';
        return this.getPageContentInfos(enforceNew).then((infos) => {
            const noticeInfo = _.find(infos, { key });
            return _.get(noticeInfo, 'data.content') || '';
        });
    },
    updateNotice(content = ''): Promise<boolean> {
        const updatePageContentCommand = {
            key: 'Notice',
            description: '重要提醒',
            data: { content },
        };
        return this.updatePageContent(updatePageContentCommand);
    },

    getDocumentTitle(enforceNew?: boolean): Promise<string> {
        const key: THelpType = 'DocumentTitle';
        return this.getPageContentInfos(enforceNew).then((infos) => {
            const noticeInfo = _.find(infos, { key });
            return _.get(noticeInfo, 'data.content') || '';
        });
    },
    updateDocumentTitle(content = ''): Promise<boolean> {
        const updatePageContentCommand = {
            key: 'DocumentTitle',
            description: '知识文档文件标题',
            data: { content },
        };
        return this.updatePageContent(updatePageContentCommand);
    },

    getDocumentFiles(enforceNew?: boolean): Promise<IHelpFile[]> {
        const key: THelpType = 'DocumentFiles';
        return this.getPageContentInfos(enforceNew).then((infos) => {
            const noticeInfo = _.find(infos, { key });
            return _.get(noticeInfo, 'data.files') || '';
        });
    },
    updateDocumentFiles(files = []): Promise<boolean> {
        const updatePageContentCommand = {
            key: 'DocumentFiles',
            description: '知识文档文件列表',
            data: { files },
        };
        return this.updatePageContent(updatePageContentCommand);
    },

    getQuestion(enforceNew?: boolean): Promise<string> {
        const key: THelpType = 'Question';
        return this.getPageContentInfos(enforceNew).then((infos) => {
            const noticeInfo = _.find(infos, { key });
            return _.get(noticeInfo, 'data.content') || '';
        });
    },
    updateQuestion(content = ''): Promise<boolean> {
        const updatePageContentCommand = {
            key: 'Question',
            description: '常见问题',
            data: { content },
        };
        return this.updatePageContent(updatePageContentCommand);
    },

    getUpdate(enforceNew?: boolean): Promise<string> {
        const key: THelpType = 'Update';
        return this.getPageContentInfos(enforceNew).then((infos) => {
            const noticeInfo = _.find(infos, { key });
            return _.get(noticeInfo, 'data.content') || '';
        });
    },
    updateUpdate(content = ''): Promise<boolean> {
        const updatePageContentCommand = {
            key: 'Update',
            description: '重要更新',
            data: { content },
        };
        return this.updatePageContent(updatePageContentCommand);
    },

    getConnectAdmin(enforceNew?: boolean): Promise<string> {
        const key: THelpType = 'ConnectAdmin';
        return this.getPageContentInfos(enforceNew).then((infos) => {
            const noticeInfo = _.find(infos, { key });
            return _.get(noticeInfo, 'data.content') || '';
        });
    },
    updateConnectAdmin(content = ''): Promise<boolean> {
        const updatePageContentCommand = {
            key: 'ConnectAdmin',
            description: '联系管理员',
            data: { content },
        };
        return this.updatePageContent(updatePageContentCommand);
    },
};
